module.exports = __webpack_public_path__ + "img/skyworx.d1f84278.svg";